import React, { useState } from "react";
import classes from "./AreSureModal.module.css";
import { Col, Row } from "react-bootstrap";
import ModalSkeleton from "../../atoms/ModalSkeleton";
import Button from "../../atoms/Button";
import RenderToast from "../../atoms/RenderToast/RenderToast";

export default function AreSureModal({
  show,
  setShow,
  message,
  onYes,
  isLoading,
  showReason = false,
}) {
  console.log("showReason ", showReason);
  const [reason, setReason] = useState("");
  return (
    <ModalSkeleton width={100} show={show} setShow={setShow}>
      <div className={classes.shureModalMain}>
        <div className={classes.shureText}>
          <h4 className={`${"heading1"} ${classes.heading}`}>Are you Sure?</h4>
          <p>{message && message}</p>
        </div>

        <div className={classes.parentBtn}>
          <Button
            disabled={isLoading}
            onClick={() => setShow(false)}
            className={classes.cancel}
            label={"No"}
          />
          <Button
            disabled={isLoading}
            className={classes.send}
            label={isLoading ? "Please Wait..." : "Yes"}
            onClick={() => {
              onYes();
            }}
          />
        </div>
      </div>
    </ModalSkeleton>
  );
}
